import * as React from 'react';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from '@fluentui/react/lib';
import { RoomFilterType } from './RoomFilterType';
import { getOptimalTextColorString } from 'owa-color-utils/lib/colorUtils';
import { getPaletteAsRawColors } from 'owa-theme';

const styles = require('./RoomFilterIcon.scss');
const classNames = require('classnames/bind').bind(styles);

export interface RoomFilterIconProps {
    colorScheme: ColorScheme;
    small?: boolean;
    square?: boolean;
    roomFilterType: RoomFilterType;
    className?: string;
}

export default function RoomFilterIcon(props: RoomFilterIconProps) {
    const getIconName = (roomFilterType: RoomFilterType): string => {
        switch (roomFilterType) {
            case RoomFilterType.RoomList: {
                return ControlIcons.EMI;
            }
            case RoomFilterType.City: {
                return ControlIcons.POI;
            }
            default: {
                return null;
            }
        }
    };
    const { colorScheme } = props;
    const coinBackgroundStyle = {
        backgroundColor: getOptimalTextColorString(
            getPaletteAsRawColors().white,
            colorScheme,
            colorScheme.calPrimary
        ),
    };
    const iconName = getIconName(props.roomFilterType);
    return (
        <div
            style={coinBackgroundStyle}
            className={classNames(props.className, {
                [styles.smallContainer]: props.small,
                [styles.container]: !props.small,
                [styles.roundContainer]: !props.square,
                [styles.squaredContainer]: props.square,
            })}>
            <Icon iconName={iconName} className={styles.icon} />
        </div>
    );
}
